// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__NhkKU","rightBlock":"Footer_rightBlock__hdCC4"};